import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 pt-28 pb-16">
        <div className="relative w-full text-center">
          <span
            className="absolute inset-x-0 top-1/2 -translate-y-1/2 font-heading text-[8rem] md:text-[14rem] font-black text-primary-100 select-none pointer-events-none"
            aria-hidden="true"
          >
            404
          </span>
          <div className="relative z-10 flex flex-col items-center gap-4">
            <span className="w-14 h-14 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
              <i className="ri-compass-3-line text-3xl" aria-hidden="true" />
            </span>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              这个页面暂时还没有内容
            </h1>
            <p className="text-sm font-label text-foreground-500 break-all">{location.pathname}</p>
            <p className="max-w-md text-sm md:text-base leading-relaxed text-foreground-600">
              你可以从频道列表或专题分类重新找起，那里能看到全站的内容结构。
            </p>
            <div className="mt-2 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label px-6 py-3 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-home-4-line" aria-hidden="true" />
                返回首页
              </Link>
              <Link
                to="/channels"
                className="inline-flex items-center justify-center gap-2 border border-foreground-950/15 hover:border-primary-400 hover:text-primary-600 text-foreground-800 font-label px-6 py-3 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-list-check-2" aria-hidden="true" />
                浏览频道列表
              </Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}